import { forwardRef } from "react";

const withCircle = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        size,
        ...props
      }: {
        size: number;
      } & any,
      ref: any,
    ) => {
      const { sx, ...rest } = props;
      return (
        <Component
          sx={{
            width: size,
            height: size,
            borderRadius: "50%",
            ...sx,
          }}
          ref={ref}
          {...rest}
        />
      );
    },
  );
};

export default withCircle;
